<script lang="ts" setup></script>
<template>
  <span class="text-red-500 text-sm block mt-1">
    <slot></slot>
  </span>
</template>

<style></style>
